import React, { useState, useEffect } from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";

const TablePaginationActions = ({ count, page, rowsPerPage, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(count / rowsPerPage));
  const [inputValue, setInputValue] = useState(String(page + 1));

  useEffect(() => {
    setInputValue(String(page + 1));
  }, [page]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputSubmit = (e) => {
    if (e.key === "Enter" || e.type === "blur") {
      const parsed = parseInt(inputValue, 10);
      if (!isNaN(parsed) && parsed >= 1 && parsed <= totalPages) {
        onPageChange(e, parsed - 1);
      } else {
        setInputValue(String(page + 1));
      }
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ml: 2, flexShrink: 0 }}>
      <IconButton
        onClick={(e) => onPageChange(e, 0)}
        disabled={page === 0}
        size="small"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={(e) => onPageChange(e, page - 1)}
        disabled={page === 0}
        size="small"
      >
        <KeyboardArrowLeft />
      </IconButton>

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mx: 1 }}>
        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>Pg.</Typography>
        <TextField
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleInputSubmit}
          onBlur={handleInputSubmit}
          size="small"
          inputProps={{
            style: { textAlign: "center", width: 36, padding: "4px 4px" },
          }}
          sx={{ "& .MuiOutlinedInput-root": { height: 28 } }}
        />
        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>/ {totalPages}</Typography>
      </Box>

      <IconButton
        onClick={(e) => onPageChange(e, page + 1)}
        disabled={page >= totalPages - 1}
        size="small"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={(e) => onPageChange(e, totalPages - 1)}
        disabled={page >= totalPages - 1}
        size="small"
      >
        <LastPage />
      </IconButton>
    </Box>
  );
};

export default TablePaginationActions;
